export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden bg-navy-900 border-y border-white/10 py-5" aria-label="Areas of capability">
      <div className="flex w-max animate-marquee motion-reduce:animate-none">
        {row.map((item, i) => (
          <span key={i} aria-hidden={i >= items.length} className="flex items-center shrink-0">
            <span className="font-mono text-sm uppercase tracking-[0.25em] text-slate-400 px-8">{item}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-teal/60" aria-hidden="true" />
          </span>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-900 to-transparent pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-900 to-transparent pointer-events-none" aria-hidden="true" />
    </div>
  );
}
